import HandshakeIcon from '@mui/icons-material/Handshake'
import HistoryIcon from '@mui/icons-material/History'
import ImportContactsIcon from '@mui/icons-material/ImportContacts'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import NotificationsIcon from '@mui/icons-material/Notifications'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import { Badge } from '@mui/material'
import { FC } from 'react'
import { Show, Tab, TabbedShowLayout, useGetList, useRecordContext } from 'react-admin'
import { HeaderTitle } from '../../components'
import { CollaborationsShowActions } from './Collaborations.actions'
import CollaborationsDetails from './Collaborations.details'
import CollaborationsDocuments from './Collaborations.documents'
import CollaborationsAuditLog from './Collaborations.audit'
import CollaborationsNotifications from './Collaborations.notifications'
import CollaborationsPartners from './Collaborations.partners'

import CollaborationsRequests from './Collaborations.requests'
import { Notificatie, Samenwerking } from '../../types/apiRequests'


const RequestsBadge: FC = () => {
  const record = useRecordContext<Samenwerking>()

  return (
    <Badge
      badgeContent={record?.aantalActieverzoeken ?? 0}
      color="info"
      overlap="circular"
    >
      <PlayCircleOutlineIcon />
    </Badge>
  )
}

const NotificationsBadge: FC = () => {
  const record = useRecordContext<Samenwerking>()

  const { total } = useGetList<Notificatie>(
    `samenwerkingen/${record?.id}/notificaties`,
    {
      pagination: { page: 1, perPage: 1 },
    },
    { enabled: !!record?.id }
  )

  return (
    <Badge
      badgeContent={total ?? 0}
      color="info"
      overlap="circular"
    >
      <NotificationsIcon />
    </Badge>
  )
}

const CollaborationsShow: FC = () => (
  <Show
    actions={<CollaborationsShowActions />}
    title={<HeaderTitle source="titel" i18n="resources.collaborations.title" />}
  >
    <TabbedShowLayout>
      <Tab label="show.details" icon={<ImportContactsIcon/>} iconPosition="start">
        <CollaborationsDetails />
      </Tab>
      <Tab
        label="show.partners"
        path="partners"
        icon={<HandshakeIcon/>}
        iconPosition="start"
      >
        <CollaborationsPartners />
      </Tab>
      <Tab
        label="show.documents"
        path="documents"
        icon={<InsertDriveFileIcon/>}
        iconPosition="start"
      >
        <CollaborationsDocuments />
      </Tab>
      <Tab
        label="show.requests"
        path="requests"
        icon={<RequestsBadge />}
        iconPosition="start"
      >
        <CollaborationsRequests />
      </Tab>
      <Tab
        label="show.notifications"
        path="notifications"
        icon={<NotificationsBadge />}
        iconPosition="start"
      >
        <CollaborationsNotifications />
      </Tab>
      <Tab
        label="show.audit"
        path="audit"
        icon={<HistoryIcon />}
        iconPosition="start"
      >
        <CollaborationsAuditLog />
      </Tab>
    </TabbedShowLayout>
  </Show>
)

export default CollaborationsShow
